import React, { useState } from 'react';
import { connect } from 'react-redux';
import CommonModal from '../../CommonComponents/CommonModal';
import CommonSelect from '../../CommonComponents/CommonSelect';
import { getAllDashUsers, showUserForm, assignProduct } from '../../redux/actions/dashusers';
import CommonMultiSearch from '../../CommonComponents/CommonMultiSearch';
import CommonSearch from '../../CommonComponents/CommonSearch';
import { showToast } from '../../Utils';
import { getClientsByCompanyCode, getProductsByClientId } from '../../redux/actions/common';

const AssignMultipleBrands = ({
  showForm, user, productAssignment, companies, clients, products,
  fetchClients,
  fetchProducts,
}) => {
  const [selectedProducts, setSelectedProducts] = useState([])
  const [selectedClient, setSelectedClient] = useState(null)

  const handleChangeCompanies = (val) => {
    fetchClients(val)
    setSelectedClient(null)
    setSelectedProducts([])
  }

  const handleChangeClients = (val) => {
    if (val) {
      setSelectedClient(val)
      fetchProducts(val.value)
      setSelectedProducts([])
    } else {
      setSelectedClient(null)
      setSelectedProducts([])
    }
  }

  const handleChangeProducts = (val) => {
    setSelectedProducts(val)
  }

  const assign = () => {
    if (selectedProducts.length > 0) {
      const brands = selectedProducts.map((item) => item.key)
      const data = {
        dashUserId: user.id,
        brands,
      }
      productAssignment(data)
    } else {
      showToast('warning', 'Please select atleast one product.')
    }
  }
  const options = products && products.filter((item) => (
    user.managerProducts.findIndex((itm) => itm.productId === item.key) === -1
  ) && item)

  return (
    <CommonModal
      title="Assign Products To Manager"
      width="md"
      open
      onYes={assign}
      onClose={() => showForm(0)}
      successButtonText="Assign"
      cancelButtonText="Cancel"
      disableEscapeKeyDown
      disableBackdropClick
    >
      <CommonSelect label="Companies" options={companies} handleChange={handleChangeCompanies} />
      <br />
      <CommonSearch label="Clients" value={selectedClient} data={clients} onChange={handleChangeClients} />
      <br />
      <CommonMultiSearch label="Products" selectedValue={selectedProducts} data={options} onChange={handleChangeProducts} />
    </CommonModal>
  );
}

const mapState = (state) => ({
  clients: state.common.clients,
  companies: state.common.companies,
  products: state.common.productFilter,
});

const mapActions = {
  getUsers: getAllDashUsers,
  showForm: showUserForm,
  productAssignment: assignProduct,
  fetchClients: getClientsByCompanyCode,
  fetchProducts: getProductsByClientId,
};

export default connect(mapState, mapActions)(AssignMultipleBrands);
